<template>
  <div>
    <lida-table
      :propscolumns="columns(query.gamelist)"
      :data="totalItems"
      :sortStatus="false"
      align="right"
      :SpinLoading="loading"
      :propsPageSize="50"
      class="my-2"
      :LeaveSpace="false"
    >
      <template v-slot:headerSelect>
        <p class="title text-left">全部</p>
      </template>
    </lida-table>
    <lida-table
      v-for="(it, key) in totalData"
      :key="key"
      :propscolumns="columns(key)"
      :data="it"
      :sortStatus="false"
      align="right"
      :SpinLoading="loading"
      :propsPageSize="50"
      class="my-2"
      :LeaveSpace="false"
      :ref="[`table${key}`]"
    >
      <template v-slot:headerSelect>
        <p class="title text-left">{{getGamename(key)}}</p>
      </template>
    </lida-table>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import switchHie from "../mixins/switchHie.js"
import reportCount from '@/mixins/report-count.js'
export default {
  name: 'reporta8',
  mixins: [reportCount, switchHie],
  data () {
    return {
      totalData: [],
      loading: false,
      notSunArray: ['indexNumber', 'date'],
    }
  },
  computed: {
    ...mapGetters(['lidaTableCheck',]),
  },
  created () {
    this.getTableData()
  },
  methods: {
    columns (gameid) {
      return {
        indexNumber: {
          title: '序号',
          align: 'center',
          key: 'indexNumber',
          width: 50
        },
        date: {
          title: '日期',
          align: 'center',
          key: 'date',
          totaltext: '总计',
          width: 200,
          render: (h, params) => {
            if (this.checkFooterText(params.row.date)) {
              return h('p', params.row.date)
            } else {
              return h('a', {
                on: {
                  click: () => this.$router.push({ name: 'general-ledger-reporta9', query: { ...this.query, date: params.row.date, gmclist: gameid, gameid }, params: { scrollGameid: gameid } })
                }
              }, params.row.date)
            }

          },
        },
        cou: {
          title: '注数',
          align: 'center',
          key: 'cou',
          total: true,
          minWidth: 2,
          render: (h, params) => h('span', this.$commaFormat(params.row.cou))
        },
        value: {
          title: '下注金额',
          align: 'center',
          key: 'value',
          total: true,
          minWidth: 20,
          render: (h, params) => this.renderColorAmount(h, params, 'value')
        },
        bonus: {
          title: '奖金',
          align: 'center',
          key: 'bonus',
          className: 'trigger-show',
          triggerShow: true,
          total: true,
          minWidth: 30,
          render: (h, params) => this.renderColorAmount(h, params, 'bonus')
        },
        payds: {
          title: '佣金',
          align: 'center',
          key: 'payds',
          className: 'trigger-show ',
          triggerShow: true,
          total: true,
          render: (h, params) => this.renderColorAmount(h, params, 'payds')
        },
        mpaysum: {
          title: '会员盈亏',
          align: 'center',
          key: 'mpaysum',
          total: true,
          minWidth: 30,
          render: (h, params) => this.renderColorAmount(h, params, 'mpaysum')
        },
      }
    },
    async getTableData () {
      this.loading = true
      try {
        const data = {
          ...this.query,
          stid: this.query.stidlist || this.query.stid,
          repnum: 8,
        }
        const res = await this.$axios.generalLedger.linkreporta2_9(data)
        if ('status' in res && res.status === 0) return
        this.totalData = res
        this.sunTotal({ name: 'date' })
      } catch (error) {
        console.error(error);
        this.checkUrl(error)
      } finally {
        this.loading = false
      }
    }
  }
}
</script>